import { DataKYCFileTct, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';
import { groupBy } from 'lodash';

export interface InvestorKycFiles {
	PROOF_OF_IDENTITY?: DataKYCFileTct[];
	PROOF_OF_ADDRESS?: DataKYCFileTct[];
	FORM?: DataKYCFileTct[];
	INVESTMENT_VEHICLE?: DataKYCFileTct[];
}

export const getInvestorKycFiles = (investor?: GetKYCInvestorInstanceRes) => {
	const activeFiles = investor?.kycFiles?.filter((file) => !file.deleted);
	return groupBy(activeFiles, 'type');
};
